import { render, staticRenderFns } from "./tripItem.vue?vue&type=template&id=b4ff2eb4&"
import script from "./tripItem.vue?vue&type=script&lang=js&"
export * from "./tripItem.vue?vue&type=script&lang=js&"
import style0 from "./tripItem.vue?vue&type=style&index=0&id=b4ff2eb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports